import { Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

/**
 * "Didn't get a code? Resend" with its cooldown, and "Wrong email? Change
 * it" when the address can be changed.
 */
@Component({
  selector: 'app-code-resend',
  templateUrl: './code-resend.component.html',
  imports: [TranslocoModule],
  host: { class: 'flex flex-col gap-3 text-center text-13 tracking-tight' },
})
export class CodeResendComponent {
  /** Seconds until "Resend" is offered again; 0 offers it. */
  readonly resendIn = input.required<number>();

  readonly busy = input(false);

  readonly changeable = input(true);

  readonly resend = output<void>();

  readonly changeEmail = output<void>();
}
